import styles from "./StandaloneTextInputGroup.module.css";
import { SearchIcon } from "./Icons";
import { classnames } from "../../utils/index.jsx";

export default function StandaloneTextInputGroup({
  placeholder,
  onChange,
  className,
  value,
}) {
  return (
    <div className={classnames(styles.inputGroup, className)}>
      <div className={styles.inputGroupText}>
        <SearchIcon />
      </div>

      <input
        type="text"
        className={styles.inputSearch}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
      />
    </div>
  );
}
